import { useState } from "react";
import logo from "../img/Final logo.PNG";
import { NavLink } from "react-bootstrap";
import "./header.css";
import Container from "react-bootstrap/Container";
import { RxCross1 } from "react-icons/rx";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { IoSearch } from "react-icons/io5";
import { useGSAP } from "@gsap/react";
import gsap from 'gsap';
const Header = ({setSearchValue}) => {
useGSAP(()=>{
  let tl=gsap.timeline()
   tl.from(".nav-container",{
    y:-300,
    duration:0.7,
    opacity:0,
stagger:1
  })

})
const [data,setData]=useState({
  searchData:""
})
const handleSearchData = (e) => {
  const newValue = e.target.value;
  setData({ [e.target.name]: newValue });
  setSearchValue(newValue); 
};

  const [search, setSearch] = useState(false);
  const HandleSearch = () => {
    if (search) {
      setSearch(false);
    } else {
      setSearch(true);
    }
   setData({
      searchData:""
   })
setSearchValue(false)

  };
  return (
    <header className="header py-0">
    <div className="header-container">
      <div className="design"></div>
    <Navbar expand="lg" className="py-0">
      <Container>
        <Navbar.Brand href="/">
         <img src={logo} className="logo"/>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav"  />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto nav-container">
         
            <NavLink href="/" className="nav-elements ">Home</NavLink>
             <NavLink href="/abouts" className="nav-elements ">About Us</NavLink> 
             <NavLink href="/products" className="nav-elements ">Products</NavLink>
              <NavLink href="/clients" className="nav-elements ">Clients</NavLink>  
                      <NavLink href="/certificates" className="nav-elements ">Certificates</NavLink>
            <NavLink href="/contact" className="nav-elements ">Contact</NavLink>
    <a href="/Company Profile BDE.pdf" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
        <div className="nav-elements">Profile</div></a>
         <a href="/BROCHURE.pdf" target="_blank" rel="noopener noreferrer" className="text-decoration-none brouchure">
        <div className="nav-elements">Brochure</div></a>
       
           <div href="/" className="search-icon ">
              <IoSearch onClick={HandleSearch} />
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>

      {search ? (
        <>
          <div className="searchOverlap">
          <div className="d-flex justify-content-center">
              <input className="search my-4" placeholder="Search Here..." name="searchData" value={data.searchData} onChange={handleSearchData}/>
            <RxCross1 className="mt-4" onClick={HandleSearch} />

          </div>
          
           
          </div>
        </>
      ) : (
        ""
      )}
    </Navbar>
    </div>
    </header>
  );
};
export default Header;
